// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__2EEdU"};